// extracted by mini-css-extract-plugin
export default {"action-button":"StyledActionButton_action-button__2R3pX","icon":"StyledActionButton_icon__j0w0h"};